import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './ContactPerson.module.scss';

@injectIntl
export default class ContactPerson extends Component {
  static propTypes = {
    person: PropTypes.object.isRequired
  };

  render() {
    const {
      person: { fullName, photo, email, phoneNumber },
      className
    } = this.props;

    return (
      <div className={`${styles.PersonBox} ${className}`}>
        <img
          alt="Contact Person"
          className={styles.Image}
          src={OptimizeImagesService.adjustImageSize(photo)}
        />
        <p className={styles.NameParagraph}>{fullName}</p>
        <a href={`mailto:${email}`} className={styles.Paragraph}>
          {email}
        </a>
        <p className={styles.Paragraph}>{phoneNumber}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ContactPerson/ContactPerson.js